import { Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationPIN from "../../../../../../../assets/animation/pin.json"
import Lottie from "react-lottie"
import useAuth from "../../../../../../../context/auth"
import { useState } from "react"
import { LoadingButton } from "@mui/lab"
import { ClientsService } from "../../../../../../../services/clients"
import { PinCode } from "../confirmNumber/pin"

interface Props {
    open: boolean,
    onClose: () => void,
    onConfirm: () => void,
}

const options = {
    loop: true,
    autoplay: true,
    animationData: animationPIN,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalLockCode = ({
    onClose,
    onConfirm,
    open
}: Props) => {
    const { getData } = useAuth()
    const [disabled, setDisabled] = useState(true)
    const [loading, setLoading] = useState(false)
    const [code, setCode] = useState("")

    const checkCode = () => {
        setLoading(true)
        ClientsService.checkPINCode(code)
            .then(async () => {
                await getData()
                onClose()
                onConfirm()
            })
            .finally(() => setLoading(false))
    }

    return (
        <ModalComponent
            open={open}
            withoutHeader
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >

                <div style={{ width: "15.2rem", height: 'auto' }}>
                    <Lottie options={options} />
                </div>

                <Typography fontWeight={700} textAlign={"center"} fontSize={"3.2rem"}>INFORME SEU CÓDIGO ABAIXO</Typography>

                <Typography fontSize={"1.4rem"} sx={{ opacity: .5 }} textAlign={"justify"}>
                    Já enviamos SEU CÓDIGO para seu endereço através dos correios, abra a correspondência onde está o seu CÓDIGO e informe abaixo:
                </Typography>

                <PinCode onChange={(confirm, value) => {
                    setDisabled(!confirm)
                    setCode(value)
                }} quantity={3} />

                <LoadingButton variant="contained" disabled={disabled} loading={loading} onClick={checkCode}>Continuar</LoadingButton>
                <Button
                    sx={{
                        height: "4rem",
                        color: "gray"
                    }}
                    onClick={onClose}
                >Cancelar</Button>
            </Grid>

        </ModalComponent >
    )
}